const translations = {
    buttonText: 'Delete',
    confirmDeleteProductUsageReport: 'Delete Report?',
    confirmDeleteProductUsageReportMessage: 'Are you sure you want to delete this report?',
    confirmDeleteProductUsageReportSubtextMessage: 'This action can not be undone.'
};

export default translations;
